module.exports = __webpack_public_path__ + "assets/img/ic-arrow-tri.af5d2893.svg";